import {AttributePropertiesPluginRegistry} from "./AttributePropertiesPluginRegistry";
import {CurrencyAttributePropertiesPlugin} from "./CurrencyAttributePropertiesPlugin";

const rendererPluginRegistry = new AttributePropertiesPluginRegistry();
rendererPluginRegistry.registerPlugin(new CurrencyAttributePropertiesPlugin());

export default rendererPluginRegistry;